<template>
	<div>
		<loader v-if="isLoading" object="#65C523" color1="#ffffff" color2="#17fd3d" size="5" speed="2" bg="#343a40" objectbg="#999793" opacity="80" disableScrolling="false" name="circular"></loader>
<!--		<formInput :refs="'WORK_JOB'"></formInput>-->
    <formSelectDadata :refs="'WORK_JOB'"></formSelectDadata>
<!--    <formSelectDadata :refs="'WORK_TITLE'"></formSelectDadata>-->
		<formSelect :refs="'EXPER_RADIO'"></formSelect>
		<formInput :refs="'CONST_INCOME'"></formInput>
<!--		<formInput :refs="'AVERAGE_EXPENSES_PER_MONTH'"></formInput>-->
<!--		<formInput :refs="'AVERAGE_MONTHLY_EXPENSES_FOR_LOAN_PAYMENTS'"></formInput>-->
		<formSelect :refs="'SOURCE_OF_INCOME'"></formSelect>
		<formSelect :refs="'PURPOSE_OF_THE_LOAN'"></formSelect>
<!--		<formSelect :refs="'FINANCIAL_POSITION'"></formSelect>-->
		<formSelect :refs="'EDUCATION'"></formSelect>
		<formSelect :refs="'MARITAL_STATUS'"></formSelect>
		<formCheckBox :name="'MINOR_CHILDREN'" :true-value="'true'" :false-value="'false'" ></formCheckBox>
<!--    <formInput :refs="'MEETING_DATE'"></formInput>-->
<!--    <formInput :refs="'MEETING_HOUR'"></formInput>-->
	</div>
</template>

<script>
	import {mapState} from 'vuex';
	export default {
		name: "scrContact",
		data(){
			return {
				isLoading: false,
			}
		},
		components:{
			loader:       () => import('@/components/abt/loader_box'),
			formInput:    () => import('@/components/abt/form/abtInput'),
			formSelect:   () => import('@/components/abt/form/abtSelect'),
			formCheckBox: () => import('@/components/abt/form/abtCheckBox'),
      formSelectDadata: () => import('@/components/abt/form/abtSelectDadata'),
			//fmSelect:   () => import('@/components/form/fmSelect'),
			//nxtButton:  () => import('@/components/form/nextButton'),
			//fmCheckBox: () => import('@/components/form/fmCheckBox'),
			//fmCheckBoxB:() => import('@/components/form/fmCheckBoxB'),
		},
		methods:{ },
		computed:{
			...mapState({
				valueVuex:      state => state.Form.sendData,
				statusVuex:     state => state.Form.workData,
				minBaseProduct: state => state.Deal.minBaseProduct,
				maxBaseProduct: state => state.Deal.maxBaseProduct,
			}),
		},
		mounted() {
			this.$store.dispatch('hideLoading');
			window.dblClick = false;
			if (window.ym) {
				// eslint-disable-next-line no-undef
				ym(51632228, 'reachGoal', 'variantB_fio');
			}
		}
	}
</script>

<style scoped>

</style>
